import type { TErrorCodes } from './hooks/useDataValidation/types';

export enum ValidationConfigPopperHandlerEnum {
  PREVIOUS_STEP,
  DOWNLOAD_TEMPLATE,
}

export enum ValidationConfigErrorHandlerEnum {
  SHOW_DETAIL,
}

export type ValidationConfigPopperProps = {
  title: string;
  body: string;
  button: string;
  handler?: ValidationConfigPopperHandlerEnum;
};

export type TSubError = {
  subCode: number;
  title: string;
  subtitle: string;
};

export type TValidationConfigType = {
  codes: TErrorCodes;
  subCodes?: TSubError[];
  label: string;
  buttonLabel: string;
  popper?: ValidationConfigPopperProps;
  handleError?: ValidationConfigErrorHandlerEnum;
};

export interface TStep2Config {
  templateUrl: string;
  validations: TValidationConfigType[];
}
